import apiClient from './client';

/**
 * Client-side checkout configuration (#666). `enabled` is false whenever billing
 * is not fully configured on the backend, so the UI hides the supporter CTA.
 */
export interface BillingConfig {
  enabled: boolean;
  environment?: string | null;
  client_token?: string | null;
  price_id?: string | null;
}

export interface BillingStatus {
  is_supporter: boolean;
  supporter_until?: string | null;
}

export const billingApi = {
  getConfig: () => apiClient.get<BillingConfig>('/api/v1/billing/config'),
  getStatus: () => apiClient.get<BillingStatus>('/api/v1/billing/status'),
};
